// extracted by mini-css-extract-plugin
export default {"topic":"style_topic__bwyaH","content":"style_content__ITslZ","galery_img":"style_galery_img__3lNZC","reference":"style_reference__hLbE6"};